import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tagName"];
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
function AbstractElement(_ref) {
  let {
      children,
      tagName
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Tag = tagName;
  return /*#__PURE__*/_jsx(Tag, Object.assign({}, rest, {
    children: children
  }));
}
AbstractElement.propTypes = {
  children: PropTypes.node,
  tagName: PropTypes.string.isRequired
};
AbstractElement.defaultProps = {
  tagName: 'span'
};
AbstractElement.displayName = 'AbstractElement';
export default AbstractElement;